// extracted by mini-css-extract-plugin
module.exports = {"page":"TopMenu_page__I3Kpo","dark":"TopMenu_dark__1rXUe","open":"TopMenu_open__2-w4c","frog":"TopMenu_frog__2lLy6"};